<template>
  <div class="deduction-detail" v-show="isShow" @click.stop.prevent="hideDetail">
    <div class="detail-wrapper" @click.stop.prevent>
      <div class="header">
          <span>商品名称</span>
          <span>券消费</span>
          <span>抵扣金额</span>
      </div>
      <ul class="content">
        <li v-for="item in deductionList" :key="item.skuId">
          <div class="product-info">
            <span>{{item.productName}}</span>
            <span>x{{item.productCount}}</span>
          </div>

          <dl class="card-deduction-info">
            <dd v-for="coupon in item.couponList" :key="coupon.couponNum">
              <div class="deducted-recharge">
                <div>
                  <span class="yen">-&yen;</span><span>{{coupon | priceDeduction('deductionValue') | couponPriceFrist}}</span><span class="decimal">{{coupon | priceDeduction('deductionValue') | couponPriceSecond}}</span>
                  <span>{{coupon.consumeRemark?`（${coupon.consumeRemark}）` : ''}}</span>
                  <!-- <span class="unit">{{coupon | priceDeduction('deductedRecharge', 'deductedCount') | couponPriceThird}}</span> -->
                </div>
                <div>
                  <span>{{coupon.couponName || "现金券"}}</span>
                  <span>{{coupon.couponNum | couponNum}}</span>
                </div>
              </div>
              <div class="deduction-value">
                <span>
                  <span class="yen">-&yen;</span><span>{{coupon | priceDeduction('deductionValue') | couponPriceFrist}}</span><span class="decimal">{{coupon | priceDeduction('deductionValue') | couponPriceSecond}}</span>
                </span>
              </div>
            </dd>

            <dd v-for="card in item.cardList" :key="card.cardNum">
              <div class="deducted-recharge">
                <div>
                  <span class="yen">-&yen;</span><span>{{card | priceDeduction('deductedRecharge', 'deductedCount') | cardPriceFrist}}</span><span class="decimal">{{card | priceDeduction('deductedRecharge', 'deductedCount') | cardPriceSecond}}</span><span class="unit">{{card | priceDeduction('deductedRecharge', 'deductedCount') | cardPriceThird}}</span>
                  <span>{{card.consumeRemark? `（${card.consumeRemark}）` : ''}}</span>
                </div>
                <div>
                  <span>{{card.cardName}}</span>
                  <span>{{card.cardNum | cardNum}}</span>
                </div>
              </div>
              <div class="deduction-value">
                <span>
                  <span class="yen">-&yen;</span><span>{{card | priceDeduction('deductionValue', 'deductedCount') | cardPriceFrist}}</span><span class="decimal">{{card | priceDeduction('deductionValue', 'deductedCount') | cardPriceSecond}}</span>
                </span>
              </div>
            </dd>
          </dl>
        </li>
      </ul>
      <div class="amount">
        <span>小计</span>
        <!-- <span :style="`visibility: ${hasMixCard ? 'hidden' : ''}`">
          {{totalCard | priceDeduction('totalDeductedRecharge', 'totalDeductedCount') | cardPriceFrist}}
          <span class="decimal">{{totalCard | priceDeduction('totalDeductedRecharge', 'totalDeductedCount') | cardPriceSecond}}</span>
          <span class="unit">{{totalCard | priceDeduction('totalDeductedRecharge', 'totalDeductedCount') | cardPriceThird}}</span>
        </span> -->
        <span></span>
        <span>
          <span class="yen">&yen;</span>
            {{totalPrice | priceDeduction('totalDeductionValue', 'totalDeductedCount') | cardPriceFrist}}
            <span  class="decimal">{{totalPrice | priceDeduction('totalDeductionValue', 'totalDeductedCount') | cardPriceSecond}}</span>
          </span>
      </div>
    </div>
  </div>

</template>
<script>
    import { mapState, mapActions } from 'vuex'
    import op from 'object-path'

    export default {
        props: ['isShow'],
        data() {
            return {
              showCouponDeduction: false,
            }
        },
        mounted() {
          this.$nextTick(() => {
            //只有在结算页面中才显示
            this.showCouponDeduction = this.$route.name == 'preorder'
          })
        },
        computed: {
          ...mapState({
            orderType: state => state.preorder.orderType,
            skuList: state => state.preorder.preorderSkuList,
            goodList: state => state.preorder.preorderGoods,
            filmData: state => state.preorder.filmData,
            // totalDeductedRecharge: state => op(state.preorder.selectedCards).get('deductionInfo.deductedRecharge') || 0,
            // totalDeductedCount: state => op(state.preorder.selectedCards).get('deductionInfo.deductedCount') || 0,
            totalCardDeductionValue: state => op(state.preorder.selectedCards).get('deductionInfo.deductionValue') || 0,
            totalCouponDeductionValue: state => op(state.preorder.selectedCoupon).get('deductionInfo.deductionValue') || 0,
            cardEpayList: state => op(state.preorder).get('selectedCards.epayList'),
            expressSku: state => state.preorder.expressSku,
            cardList: state => state.preorder.cardsList,
            couponList: state => state.preorder.couponsList,
            couponEpayList: state => op(state.preorder).get('selectedCoupon.epayList'),
          }),
          selectedCard() {
            return this.cardEpayList && this.cardEpayList.map(epay => {
              // const cardInfo = this.cardList.find(card => card.epayNumber === epay.epayNumber) || {}
              return {displayType: op(epay).get('extraInfo.displayType'), displayName: op(epay).get('extraInfo.displayName') , ...epay}
            })
          },
          selectedCoupon() {
            return this.couponEpayList && this.couponEpayList.map(epay => {
              return {displayType: op(epay).get('extraInfo.displayType'), displayName: op(epay).get('extraInfo.displayName') , ...epay}
            })
          },
          deductionList() {
            const vm = this
            const selectedCard = vm.selectedCard || []
            const selectedCoupon = vm.selectedCoupon || []
            return selectedCard
              .concat(this.showCouponDeduction ? selectedCoupon : [])
              .reduce((productList, card) => {
                // 获取所有进行了抵扣的skuId
                productList = card.deductionList.reduce((skuList, sku) => {
                  productList.push(sku.skuId)
                  return productList
                }, productList)
                return [...new Set(productList)]
              }, [])
              .map((id) => {
                // 根据skuId获取商品数量
                let sku = vm.skuList.find((item) => {
                  return item.skuId === id
                })

                // 运费特殊处理
                if (!sku) {
                  if (this.expressSku && this.expressSku.skuId == id) {
                    return {
                      skuId: id,
                      productCount: 1
                    }
                  } else {
                    return {}
                  }
                }

                return {
                  skuId: sku.skuId,
                  productCount: sku.count
                }
              })
              .map((item) => {
                // 拼接商品名称
                let productName = ''

                // 运费特殊处理
                if (this.expressSku && this.expressSku.skuId == item.skuId) {
                  productName = '运费'
                } else {
                  if (vm.orderType == 1) {
                    const product = vm.goodList.find((good) => {
                      return good.sku.skuId === item.skuId
                  })
                    productName = product && product.productBaseInfo.masterName || ''
                  } else if (vm.orderType == 2) {
                    productName = vm.filmData.goodsInfo[0].seatExtInfo.filmName
                  }
                }
                item.productName = productName

                // 拼接卡抵扣信息
                let cardList = selectedCard
                  .filter(card => {
                    return card.deductionList.some(sku => {
                      return sku.skuId === item.skuId
                    })
                  })
                  .reduce((cardList, card) => {
                    const skuInfo = card.deductionList.find(sku => {
                      return sku.skuId === item.skuId
                    })
                    cardList.push({
                      displayType: card.displayType,
                      cardName: card.displayName,
                      cardNum: card.epayNumber,
                      consumeRemark: card.consumeRemark || '',
                      deductionValue: skuInfo.deductionValue,
                      deductedCount: skuInfo.deductedCount,
                      deductedRecharge: skuInfo.deductedRecharge,
                    })
                    return cardList
                  }, []) || []
                item.cardList = cardList

                if(this.showCouponDeduction) {
                    // 拼接现金券抵扣信息
                  let couponList = selectedCoupon
                    .filter(coupon => {
                      return coupon.deductionList.some(sku => {
                        return sku.skuId === item.skuId
                      })
                    })
                    .reduce((couponList, coupon) => {
                      const skuInfo = coupon.deductionList.find(sku => {
                        return sku.skuId === item.skuId && sku.deductionValue != 0
                      })

                      if(skuInfo) {
                        couponList.push({
                          displayType: coupon.displayType,
                          couponName: coupon.displayName,
                          couponNum: coupon.epayId,
                          consumeRemark: coupon.consumeRemark || '',
                          deductionValue: skuInfo.deductionValue,
                          deductedCount: skuInfo.deductedCount,
                          deductedRecharge: skuInfo.deductedRecharge,
                        })
                      }

                      return couponList
                    }, []) || []

                    item.couponList = couponList
                }

                return item
              })
              .reduceRight((list, item) => {
                // 把运费放到列表最后
                if (this.expressSku) {
                  if (item.skuId == this.expressSku.skuId) {
                    list.push(item)
                    return list
                  }
                }
                list.unshift(item)
                return list
              }, [])
              .filter(function(item) {
                return op(item.cardList).get('length') || op(item.couponList).get('length');
              })
          },
          totalPrice() {
            return {
              // displayType: this.showCouponDeduction? op(this.selectedCard).get('0.displayType') : ,
              // totalDeductedCount: this.totalDeductedCount,
              // totalDeductedRecharge: this.totalDeductedRecharge,
              totalDeductionValue: this.showCouponDeduction?  this.totalCardDeductionValue + this.totalCouponDeductionValue : this.totalCardDeductionValue
            }
          },
          /* hasMixCard() {
            // 如果同时勾选了次卡和礼包卡
            return this.selectedCard && this.selectedCard.length
              && this.selectedCard.some(card => card.displayType == 1)
              && this.selectedCard.some(card => card.displayType == 4)
          } */
        },
        methods: {
          hideDetail() {
            this.$emit('hideDetail')
          }
        }
    }
</script>

<style lang="less" scoped>
@import '../../stylesheet/variable.less';

.deduction-detail {
  ul, dl, dd {
    margin: 0;
    padding: 0;
    list-style-type: none;
  }
  .decimal {
    display: inline-block;
    min-width: 4px;
    margin-left: -4px;
    transform-origin: 50% 7px;
    transform: translate(2px, 2px) scale(0.7);
  }
  position: fixed;
  bottom: 49px;
  z-index: 300;
  width: 100%;
  height: calc(~'100vh - 49px');
  background-color: rgba(0, 0, 0, 0.3);
  .detail-wrapper {
    box-sizing: border-box;
    width: 100%;
    background-color: #fff;
    position: absolute;
    bottom: 0;
    font-size: 13px;
    color: @darkGrey;
    .header, .amount {
      padding: 0 15px;
      height: 39px;
      position: relative;
      & > span {
        display: flex;
        align-items: center;
        justify-content: flex-start;
        float: left;
        height: 39px;
      }
      & > span:nth-child(1) {
        width: 42%;
      }
      & > span:nth-child(2) {
        width: 29%;
      }
      & > span:nth-child(3) {
        width: 29%;
        justify-content: flex-end;
      }
    }
    .header {
      background-color: rgb(249,249,249);
    }
    .header::after {
      .setBottomLine();
    }
    .content {
      max-height: 237px;
      overflow: scroll;
      overflow-x: hidden;
      -webkit-overflow-scrolling: touch;
      & > li:last-child::after {
        border: none;
      }
      li {
        padding: 0 15px;
        margin-top: 15px;
        position: relative;
        display: flex;
        &::after {
          .setBottomLine();
        }
        .product-info {
          width: 42%;
          flex-direction: column;
          display: flex;
          & > span {
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            display: block;
            width: 80%;
          }
          & > span:nth-child(2) {
            color: @lightSliver;
            margin-top: 5px;
          }
        }
        .card-deduction-info {
          width: 58%;
          dd {
            height: 40px;
            margin-bottom: 11px;
            display: flex;
            .deducted-recharge {
              width: 70%;
              display: flex;
              flex-direction: column;
              & > div:nth-child(1) {
                span:last-child {
                  font-size:11px;
                  color:rgb(175, 179, 184)
                }
              }
              & > div:nth-child(2) {
                display: block;
                flex-direction: row;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
                font-size: 11px;
                color: @lightSliver;
                margin-top: 5px;
                width: 100%;
              }
            }
            .deduction-value {
              width: 30%;
              text-align: right;
              color: @orange;

            }
            .yen {
                font-size: 12px;
                display: inline-block;
                transform-origin: 50% 6px;
                transform: translate(0px, 2px) scale(0.7);
              }
          }
        }
      }
    }
    .amount {
      & > span:nth-child(3) {
        color: @orange;
      }
      &::before {
        .setTopLine();
      }
      &::after {
        .setBottomLine();
      }
      .yen {
        font-size: 12px;
        transform-origin: 50% 7px;
        transform: translate(0px, 2px) scale(0.7);
      }
    }
  }
}

</style>

